<template>
  <AppLayout>
    <VFlex xs12>
      <VCard v-if="currentContract">
        <VCardText>
          <h1 class="mb-1">
            {{ currentContract.elsazeit_company_name }}
          </h1>

          <p class="mb-1">
            <b>{{ $t('subscriptionStatus') }}: </b>
            {{ $t(currentContract.elsazeit_user_subscription_status? 'active' : 'notActive') }}
          </p>

          <p class="mb-1">
            <b>{{ $t('subscriptionType') }}: </b>
            {{ currentContract.elsazeit_user_package }}
          </p>

          <p class="mb-1">
            <b>{{ $t('subscriptionNextPayment') }}: </b>
            {{ currentContract.elsazeit_user_package_cost / 100 | toEuro }}
          </p>
        </VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn
            color="primary"
            @click.native="$router.push({name: 'subscriptionUpdate'})"
          >
            {{ $t('subscriptionUpdate') }}
          </VBtn>
        </VCardActions>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import { mapGetters } from 'vuex'

import { toEuro } from '@/utils/customFormatters'

export default {
  name: 'Contract',
  filters: {
    toEuro
  },
  props: ['contractId'],
  computed: {
    ...mapGetters('contract', ['currentContract'])
  },
  i18n: {
    messages: {
      de: {
        package: 'Paket',
        packageCost: 'Preis pro Monat',
        subscriptionStatus: 'Abostatus',
        notActive: 'Nicht aktiv',
        subscriptionType: 'Art',
        subscriptionNextPayment: 'Ihre nächste Zahlung',
        subscriptionUpdate: 'Erneuern'
      },
      en: {
        package: 'Package',
        packageCost: 'Package price',
        subscriptionStatus: 'Subscription status',
        notActive: 'Not active',
        subscriptionType: 'Type',
        subscriptionNextPayment: 'Your next payment',
        subscriptionUpdate: 'Update subscription'
      }
    }
  }
}
</script>
